import { render, staticRenderFns } from "./VoucherPayments.vue?vue&type=template&id=7724d830&"
import script from "./VoucherPayments.vue?vue&type=script&lang=js&"
export * from "./VoucherPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports